import { NgModule } from "@angular/core";
import { EffectsModule } from "@ngrx/effects";
import { ActionReducerMap, StoreModule } from "@ngrx/store";
import { CoreModule } from "@obg/ngx.core";
import { CoreContentModule } from "@obg/ngx.core.content";
import { GlobalModule } from "@obg/ngx.global";
import { RouterModule } from "@obg/ngx.router";

import { CustomerConsistencyService } from "./customer-consistency/customer-consistency.service";
import { GameEffect } from "./game/game.effect";
import { gameReducer } from "./game/game.reducer";
import { GameCollectionEffect } from "./game-collection/game-collection.effect";
import { gameCollectionReducer } from "./game-collection/game-collection.reducer";
import { GameVariantEffect } from "./game-variant/game-variant.effect";
import { gameVariantReducer } from "./game-variant/game-variant.reducer";
import { GamingRouteEffect } from "./router/gaming-route.effect";
import { GamingExternalState } from "./state";
import { FavouriteGamesEffect } from "./user-games/favourite-games/favourite-games.effect";
import { favouriteGamesReducer } from "./user-games/favourite-games/favourite-games.reducer";
import { RecommendedGamesEffect } from "./user-games/recommended-games/recommended-games.effect";
import { recommendedGamesReducer } from "./user-games/recommended-games/recommended-games.reducer";
import { UserGamesEffect } from "./user-games/user-games.effect";
import { userGamesReducer } from "./user-games/user-games.reducer";

const GAMING_EFFECTS = [
	GameEffect,
	GameCollectionEffect,
	GameVariantEffect,
	GamingRouteEffect,
	UserGamesEffect,
	FavouriteGamesEffect,
	RecommendedGamesEffect,
];

const GAMING_REDUCER: ActionReducerMap<GamingExternalState["gamingExternal"]> = {
	game: gameReducer,
	gameCollection: gameCollectionReducer,
	gameVariant: gameVariantReducer,
	userGames: userGamesReducer,
	favouriteGames: favouriteGamesReducer,
	recommendedGames: recommendedGamesReducer,
};

@NgModule({
	providers: [CustomerConsistencyService],
	imports: [
		GlobalModule,
		CoreModule,
		CoreContentModule,
		RouterModule,
		StoreModule.forFeature("gamingExternal", GAMING_REDUCER),
		EffectsModule.forFeature(GAMING_EFFECTS),
	],
})
export class GamingExternalModule {}
